import { computed } from 'mobx';
import Model from 'core/model/Model';

/**
 * A Focus Scope granted to a role set. `active_on_login` is the role set's
 * preference for which scope a fresh session starts with; it never widens or
 * narrows what the scope itself allows.
 */
export default class RoleSetGlobalFilterModel extends Model {
  @computed
  get dataSource() {
    const { all_devices, sites = [], labels = [], device_types = [], devices = [] } = this.get('dimensions') || {};

    if (all_devices) {
      return 'All devices';
    }

    const parts = [
      sites.length && `${sites.length} site${sites.length > 1 ? 's' : ''}`,
      labels.length && `${labels.length} label${labels.length > 1 ? 's' : ''}`,
      device_types.length && `${device_types.length} device type${device_types.length > 1 ? 's' : ''}`,
      devices.length && `${devices.length} device${devices.length > 1 ? 's' : ''}`,
      this.get('has_filters') && 'ad-hoc filters'
    ].filter(Boolean);

    return parts.length ? parts.join(', ') : 'No restrictions';
  }
}
